/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateSignedChatAttachmentURLForm2,
  CreateSignedChatAttachmentURLForm2$Outbound,
  CreateSignedChatAttachmentURLForm2$outboundSchema,
} from "../components/createsignedchatattachmenturlform2.js";

export type CreateSignedChatAttachmentURLSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateSignedChatAttachmentURLSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateSignedChatAttachmentURLSecurityOption3 = {
  chatSessionsTokenHeaderGramChatSession: string;
  projectSlugHeaderGramProject: string;
};

export type CreateSignedChatAttachmentURLSecurity = {
  option1?: CreateSignedChatAttachmentURLSecurityOption1 | undefined;
  option2?: CreateSignedChatAttachmentURLSecurityOption2 | undefined;
  option3?: CreateSignedChatAttachmentURLSecurityOption3 | undefined;
};

export type CreateSignedChatAttachmentURLRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
  createSignedChatAttachmentURLForm2: CreateSignedChatAttachmentURLForm2;
};

/** @internal */
export type CreateSignedChatAttachmentURLSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateSignedChatAttachmentURLSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateSignedChatAttachmentURLSecurityOption1$Outbound,
    CreateSignedChatAttachmentURLSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createSignedChatAttachmentURLSecurityOption1ToJSON(
  createSignedChatAttachmentURLSecurityOption1:
    CreateSignedChatAttachmentURLSecurityOption1,
): string {
  return JSON.stringify(
    CreateSignedChatAttachmentURLSecurityOption1$outboundSchema.parse(
      createSignedChatAttachmentURLSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateSignedChatAttachmentURLSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateSignedChatAttachmentURLSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateSignedChatAttachmentURLSecurityOption2$Outbound,
    CreateSignedChatAttachmentURLSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createSignedChatAttachmentURLSecurityOption2ToJSON(
  createSignedChatAttachmentURLSecurityOption2:
    CreateSignedChatAttachmentURLSecurityOption2,
): string {
  return JSON.stringify(
    CreateSignedChatAttachmentURLSecurityOption2$outboundSchema.parse(
      createSignedChatAttachmentURLSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateSignedChatAttachmentURLSecurityOption3$Outbound = {
  "chat_sessions_token_header_Gram-Chat-Session": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateSignedChatAttachmentURLSecurityOption3$outboundSchema:
  z.ZodMiniType<
    CreateSignedChatAttachmentURLSecurityOption3$Outbound,
    CreateSignedChatAttachmentURLSecurityOption3
  > = z.pipe(
    z.object({
      chatSessionsTokenHeaderGramChatSession: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        chatSessionsTokenHeaderGramChatSession:
          "chat_sessions_token_header_Gram-Chat-Session",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createSignedChatAttachmentURLSecurityOption3ToJSON(
  createSignedChatAttachmentURLSecurityOption3:
    CreateSignedChatAttachmentURLSecurityOption3,
): string {
  return JSON.stringify(
    CreateSignedChatAttachmentURLSecurityOption3$outboundSchema.parse(
      createSignedChatAttachmentURLSecurityOption3,
    ),
  );
}

/** @internal */
export type CreateSignedChatAttachmentURLSecurity$Outbound = {
  Option1?: CreateSignedChatAttachmentURLSecurityOption1$Outbound | undefined;
  Option2?: CreateSignedChatAttachmentURLSecurityOption2$Outbound | undefined;
  Option3?: CreateSignedChatAttachmentURLSecurityOption3$Outbound | undefined;
};

/** @internal */
export const CreateSignedChatAttachmentURLSecurity$outboundSchema:
  z.ZodMiniType<
    CreateSignedChatAttachmentURLSecurity$Outbound,
    CreateSignedChatAttachmentURLSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(
        z.lazy(() =>
          CreateSignedChatAttachmentURLSecurityOption1$outboundSchema
        ),
      ),
      option2: z.optional(
        z.lazy(() =>
          CreateSignedChatAttachmentURLSecurityOption2$outboundSchema
        ),
      ),
      option3: z.optional(
        z.lazy(() =>
          CreateSignedChatAttachmentURLSecurityOption3$outboundSchema
        ),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
        option3: "Option3",
      });
    }),
  );

export function createSignedChatAttachmentURLSecurityToJSON(
  createSignedChatAttachmentURLSecurity: CreateSignedChatAttachmentURLSecurity,
): string {
  return JSON.stringify(
    CreateSignedChatAttachmentURLSecurity$outboundSchema.parse(
      createSignedChatAttachmentURLSecurity,
    ),
  );
}

/** @internal */
export type CreateSignedChatAttachmentURLRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
  CreateSignedChatAttachmentURLForm2:
    CreateSignedChatAttachmentURLForm2$Outbound;
};

/** @internal */
export const CreateSignedChatAttachmentURLRequest$outboundSchema: z.ZodMiniType<
  CreateSignedChatAttachmentURLRequest$Outbound,
  CreateSignedChatAttachmentURLRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
    createSignedChatAttachmentURLForm2:
      CreateSignedChatAttachmentURLForm2$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      gramSession: "Gram-Session",
      gramChatSession: "Gram-Chat-Session",
      createSignedChatAttachmentURLForm2: "CreateSignedChatAttachmentURLForm2",
    });
  }),
);

export function createSignedChatAttachmentURLRequestToJSON(
  createSignedChatAttachmentURLRequest: CreateSignedChatAttachmentURLRequest,
): string {
  return JSON.stringify(
    CreateSignedChatAttachmentURLRequest$outboundSchema.parse(
      createSignedChatAttachmentURLRequest,
    ),
  );
}
